const queryString = window.location.search;
const params = new URLSearchParams(queryString);

export const PREVIEW = (params.get('isPreview') || params.get('preview')) === 'true';
export const PROVIEW = (params.get('isProview') || params.get('proview')) === 'true';
export const LANGUAGE = params.get('language');
export const BRAND = params.get('brand');
export const APPOINTMENT_PREVIEW_TYPE = params.get('type');
export const HAS_NEW_MESSAGE = params.get('hasNewMessage') ?? false;
export const ADVICE_ID = params.get('adviceId');
export const GROUP_ID = params.get('groupId');
export const DEALER_ID = params.get('dealerId');
